import { __decorate, __metadata } from "tslib";
import { Type } from '@ftr/serialization';
import { PageDetails } from './PageDetails';
/**
 * Partially implements the JSONAPI v1.0 query parameters.
 *
 * @see Paging
 * @see https://jsonapi.org
 */
export class PagedQuery {
    constructor(page) {
        this.page = page;
    }
}
__decorate([
    Type(() => PageDetails),
    __metadata("design:type", PageDetails)
], PagedQuery.prototype, "page", void 0);
